// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class ProviderCasesResource extends Resource {
    basePath: string = 'cases/provider/';

    objectPath: string = 'cases/provider/{ident}/';
}
